import { Separator } from '@radix-ui/react-separator';
import React from 'react';

interface DrawerSwipeBtn {
  variant?: 'top' | 'bottom';
}

const DrawerSwipeBtn = React.forwardRef<HTMLDivElement, DrawerSwipeBtn>(
  ({ variant = 'bottom' }, ref) => {
    const position = variant === 'top' ? 'top-1' : 'bottom-0';
    return (
      <div ref={ref} className={`fixed ${position} w-full justify-center p-2 flex bg-white left-0`}>
        <Separator className="h-2 bg-gray-200 w-[200px] rounded-xl" />
      </div>
    );
  }
);

DrawerSwipeBtn.displayName = 'DrawerSwipeBtn';

export default DrawerSwipeBtn;
